import { render, staticRenderFns } from "./RxProtocols.vue?vue&type=template&id=9ebab5ac"
import script from "./RxProtocols.vue?vue&type=script&lang=js"
export * from "./RxProtocols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports